enum NotificationLevelEnum {
    error = "error",
    success = "success",
    warning = "warning",
    info = "info",
}

export default NotificationLevelEnum;
